import React from 'react';
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from 'react-toastify';

import App from "./App";
import store from '../utils/store';


function Root() {
  return (
    <Provider store={store}>
      <BrowserRouter>
      <ToastContainer position='top-right' />
          <App />
        </BrowserRouter>
    </Provider>
  );
}

export default Root;
